export const RENT_HISTORY_BEGIN = 'RENT_HISTORY_BEGIN';
export const RENT_HISTORY_SUCCESS = 'RENT_HISTORY_SUCCESS';
export const RENT_HISTORY_MODIFY_DEVICE_SUCCESS =
  'RENT_HISTORY_MODIFY_DEVICE_SUCCESS';
export const RENT_HISTORY_DETACH_DEVICE_SUCCESS =
  'RENT_HISTORY_DETACH_DEVICE_SUCCESS';
export const RENT_HISTORY_ERROR = 'RENT_HISTORY_ERROR';
